module.exports = __webpack_public_path__ + "img/Unicom-5.292df70d.svg";